export default __webpack_public_path__ + "static/media/travel agnecy.267c7296.png";